import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton
} from '@mui/material';
import editPenImg from '../../assets/images/CustomerManagement/edit-pen-img.svg';
import { SbAddBtn } from '../Buttons/Buttons';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Col, Form, Row } from 'react-bootstrap';
import AddLeave from './AddLeave';
import Main from '../Main';
import customerImg from '../../assets/images/CustomerManagement/customer-img.svg';
import { useNavigate } from 'react-router-dom';
import Download from '../MainSection/Download/Download';
import PaginationComponent from '../PaginationComponent';
import { useDispatch, useSelector } from 'react-redux';
import { loadSingleLeaveBalanceData, loadSingleLeaveData, loadSingleUserManagementData } from '../../redux/action';

// Table columns
const columns = [
    { id: 'StartDate', label: 'FROM DATE', align: 'left', minWidth: '180px' },
    { id: 'EndDate', label: 'TO DATE', align: 'left', minWidth: '180px' },
    { id: 'LeaveDuration', label: 'LEAVE DURATION', align: 'left', minWidth: '150px' },
    { id: 'ReportingTo', label: 'REPORTING TO', align: 'left', minWidth: '150px' },
    { id: 'LeaveTypeName', label: 'LEAVE TYPE', align: 'left', minWidth: '150px' },
    { id: 'Reason', label: 'REASON', align: 'left', minWidth: '300px' },
];

const LeaveDetailsForUser = ({ signInUserId }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [openAddLeave, setAddLeave] = useState(false);
    const { singleUserData } = useSelector((state) => state.data);
    const { singleLeaveBalanceData = [] } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { singleLeaveData = [] } = useSelector((state) => state.data);

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const handleAddLeave = () => {
        setAddLeave(true);
    };

    const handleCloseAddLeave = () => {
        setAddLeave(false);
    };

    const handleEditLeave = () => {
        setAddLeave(true);
    };

    const handleAnalyticsClick = () => {
        navigate('/attendanceDashboard')
    }

    const handleBack = () => {
        navigate(-1);
    };

    // Pagination logic
    useEffect(() => {
        if (!Array.isArray(singleLeaveData) || singleLeaveData.length === 0) {
            console.warn("⚠️ No Leave Data Found or Data is Not an Array!", singleLeaveData);
            setPaginatedData([]);
            return;
        }

        // Calculate pagination
        const maxPage = Math.ceil(singleLeaveData.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = singleLeaveData.slice(start, end);

        // Only update state if paginated data has changed
        setPaginatedData(prev => JSON.stringify(prev) === JSON.stringify(paginated) ? prev : paginated);
    }, [singleLeaveData, page, rowsPerPage]);


    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    useEffect(() => {
        if (signInUserId) {
            dispatch(loadSingleUserManagementData(signInUserId));
            dispatch(loadSingleLeaveBalanceData(signInUserId));
        }
    }, [signInUserId, dispatch]);

    const fetchSingleLeaveData = () => {
        if (signInUserId) {
            dispatch(loadSingleLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate, "", signInUserId));
        }
    };

    // Call the function inside useEffect
    useEffect(() => {
        fetchSingleLeaveData();
    }, [rowsPerPage, page + 1, searchQuery, fromDate, toDate, '', signInUserId, dispatch]);

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Leaves Details"
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onBackClick={handleBack}
                    />
                </div>

                {/* <div className="customermanagement-content"> */}
                <Row className='leaves-cards-container'>
                    {singleLeaveBalanceData[0]?.LeaveBalanceDays?.map((leave, index) => (
                        <Col key={index} md={2} className='leave-cards leave-details-card'>
                            <div className='leave-cards-counts'>
                                <b>{leave.NoofDaysAvailed}</b>
                                <p>{leave.LeaveTypeName}</p>
                            </div>
                        </Col>
                    ))}
                    <Col md={2} className='leave-cards leave-details-card'>
                        <div className='leave-cards-counts'>
                            <b style={{ height: "60px", width: "60px", margin: "0px" }}>
                                {singleLeaveBalanceData[0]?.LeaveBalanceDays
                                    ? `${singleLeaveBalanceData[0]?.LeaveBalanceDays.reduce((acc, leave) => acc + leave.NoofDaysAvailed, 0)} / 
                                   ${singleLeaveBalanceData[0]?.LeaveBalanceDays.reduce((acc, leave) => acc + leave.NoofDaysAllotted, 0)}`
                                    : "0 / 0"}
                            </b>
                            <p style={{ margin: "0px" }}>Total Leave Balance</p>
                        </div>
                    </Col>
                </Row>
                <Row className='m-0 employee-leaves-details-container'>
                    <Col md={9} className='customermanagement-search-filter p-0'>
                        <div className='customermanagement-content-container'>
                            <div className="customermanagement-content">
                                <Row className='customermanagement-btns-container'>
                                    <Col md={3} className='customermanagement-backbtn-div'>
                                        <span>{[singleUserData[0]?.FirstName, singleUserData[0]?.MiddleName, singleUserData[0]?.LastName].filter(Boolean).join(" ")}</span>
                                    </Col>
                                    <Col md={9} className='customermanagement-search-filter'>
                                        <Col md={3} className='filters-col'>
                                            <div className='customermanagement-search'>
                                                <Form.Control type="search" placeholder='Search' />
                                                <img src={searchIcon} alt="Search" />
                                            </div>
                                        </Col>
                                        <Col md={3} className='filters-col'>
                                            <div className='calendar-container'>
                                                <DatePicker
                                                    className="select from-date"
                                                    id="date-range-picker-from"
                                                    dateFormat="dd/MM/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selectsRange
                                                    dropdownMode="select"
                                                    placeholderText='From'
                                                    maxDate={new Date()}
                                                />
                                                <img src={calendar} alt="Calendar" />
                                            </div>
                                        </Col>
                                        <Col md={3} className='filters-col'>
                                            <div className='calendar-container'>
                                                <DatePicker
                                                    className="select from-date"
                                                    id="date-range-picker-to"
                                                    dateFormat="dd/MM/yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selectsRange
                                                    dropdownMode="select"
                                                    placeholderText='To'
                                                    maxDate={new Date()}
                                                />
                                                <img src={calendar} alt="Calendar" />
                                            </div>
                                        </Col>
                                        {/* <SbAddBtn btnName="Add Leaves" onClickEffect={handleAddLeave} /> */}
                                    </Col>
                                </Row>

                                <div className='customermanagement-table-div leave-details-table'>
                                    <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column) => (
                                                        <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                            <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                                                {column.label}
                                                            </div>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {paginatedData.map((row, index) => (
                                                    <TableRow key={index} className='table-row-data-container'>
                                                        {columns.map((column) => (
                                                            <TableCell key={column.id} align={column.align}>
                                                                {row[column.id]}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {/* Use PaginationComponent */}
                                    <PaginationComponent
                                        totalItems={totalDataCount}
                                        itemsPerPage={rowsPerPage}
                                        onPageChange={handlePageChange}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col md={3} className='employee-profile-col'>
                        {/* Employee Profile Section */}
                        <div className="employee-profile-container">
                            <img src={customerImg} alt="Profile" className="employee-profile-img" />
                            <div className="employee-details">
                                <div className='pb-3'>
                                    <p>ID</p>
                                    <span>{singleUserData[0]?.UserID}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Name</p>
                                    <span><span>{[singleUserData[0]?.FirstName, singleUserData[0]?.MiddleName, singleUserData[0]?.LastName].filter(Boolean).join(" ")}</span>                                    </span>
                                </div>
                                <div className='pb-3'>
                                    <p>Email </p>
                                    <span>{singleUserData[0]?.EmailID}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Role </p>
                                    <span>{singleUserData[0]?.UserRoles?.map(role => role.RoleName).join(", ")}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Department </p>
                                    <span>{singleUserData[0]?.DepartmentName}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Contact </p>
                                    <span>{singleUserData[0]?.Phone}</span>
                                </div>
                                <div className='pb-3'>
                                    <p>Address</p>
                                    <span> {singleUserData[0]?.WorkAddress}</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Main >
        </div>
    );
};

export default LeaveDetailsForUser;
